<template>
  <div class="assets-page">
    <van-nav-bar title="我的资产" left-arrow @click-left="onClickLeft" />

    <section class="summary-card">
      <div class="summary-label">总资产</div>
      <div class="summary-value">{{ formatAmount(displayAssets.total_asset) }}</div>
      <div class="summary-caption">审核通过的资产余额</div>
    </section>

    <section class="asset-grid">
      <div class="asset-item">
        <div class="asset-label">中国制造余额</div>
        <div class="asset-value">{{ formatAmount(displayAssets.made_asset) }}</div>
      </div>
      <div class="asset-item">
        <div class="asset-label">中华云泊余额</div>
        <div class="asset-value">{{ formatAmount(displayAssets.yunbo_asset) }}</div>
      </div>
    </section>

    <section class="status-card">
      <div class="status-heading">
        <span>往期资产登记</span>
        <span :class="['status-tag', statusClass]">{{ statusText }}</span>
      </div>
      <p class="status-description">注：本次申报登记的资产为用户个人历史资产。所有历史资产将按照相关合规要求依法、依规全面纳入审计程序。凡经核实无误的资产均转入提现环节，并依清算程序予以款项兑付。请用户放心，审计与清算均将依照标准流程进行，确保公平、公正、透明。</p>
      <van-button
        block
        type="danger"
        :loading="loading"
        @click="status === 1 ? goWithdraw() : goRegister()"
      >
        {{ status === 1 ? "提现" : status === 0 ? "审核中" : status === 2 ? "查看申报" : "登记往期资产" }}
      </van-button>
    </section>
  </div>
</template>
<script>
import request from "@utils/request";
import { Dialog } from "vant";
const emptyAssets = {
  total_asset: 0,
  made_asset: 0,
  yunbo_asset: 0,
  asset_withdrawal: 0
};

export default {
  name: "MyAssets",
  data() {
    return {
      assets: { ...emptyAssets },
      status: -1,
      loading: false
    };
  },
  computed: {
    displayAssets() {
      return this.status === 1 ? this.assets : emptyAssets;
    },
    statusText() {
      if (this.status === 1) return "审核通过";
      if (this.status === 0) return "审核中";
      if (this.status === 2) return "审核未通过";
      return "未登记";
    },
    statusClass() {
      if (this.status === 1) return "status-success";
      if (this.status === 0) return "status-pending";
      if (this.status === 2) return "status-failed";
      return "status-default";
    }
  },
  created() {
    this.loadAssets();
  },
  methods: {
    unwrap(response) {
      const payload = response && response.data !== undefined ? response.data : response;
      return payload && payload.data !== undefined ? payload : { code: 200, data: payload };
    },

    async loadAssets() {
      this.loading = true;
      try {
        const responses = await Promise.all([
          request.get("/api/v1/user/myAssets", {}, { login: true }),
          request.get("/api/v1/user/assetStatus", {}, { login: true })
        ]);

        const assetsPayload = this.unwrap(responses[0]);
        const statusPayload = this.unwrap(responses[1]);

        if (assetsPayload.code === 200 && assetsPayload.data) {
          this.assets = Object.assign({}, emptyAssets, assetsPayload.data);
        }

        if (statusPayload.code === 200 && statusPayload.data) {
          this.status = Number(statusPayload.data.status);
        }
      } catch (error) {
        const message = error && error.response && error.response.data
          ? error.response.data.msg
          : "资产信息加载失败，请稍后重试";
        this.$dialog.error(message || "资产信息加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    formatAmount(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
    },

    goRegister() {
      this.$router.push({ path: "/assetRegister" });
    },
async goWithdraw() {
  //if (Number(this.assets.asset_withdrawal) !== 1) {
  //  Dialog.alert({
  //    title: "温馨提示",
  //    message: "为确保资金依法依规拨付，请等待所有历史资产审计完成后进行提现！",
  //    confirmButtonText: "确定"
  //  });
  //  return;
  //}

  try {
    const res = await request.get("/api/v1/user/largePayStatus", {}, { login: true });
    const payload = res && res.data !== undefined ? res.data : res;
    const data = payload && payload.data ? payload.data : payload;
    const banks = data && Array.isArray(data.bankList) ? data.bankList : [];

    if (!banks.some(item => Number(item.status) === 1)) {
      await Dialog.confirm({
        title: "温馨提示",
        message: "为确保资金依法依规拨付，请先完成数字人民币钱包绑定，绑定成功后方可进行资产提现。",
        confirmButtonText: "去绑定",
        cancelButtonText: "取消"
      });
      this.$router.push({ path: "/asset" });
      return;
    }
  } catch (e) {
    await Dialog.confirm({
      title: "温馨提示",
      message: "为确保资金依法依规拨付，请先完成数字人民币钱包绑定，绑定成功后方可进行资产提现。",
      confirmButtonText: "去绑定",
      cancelButtonText: "取消"
    });
    this.$router.push({ path: "/asset" });
    return;
  }

  this.$router.push({ path: "/assetWithdraw" });
},

    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.assets-page {
  min-height: 100vh;
  padding-bottom: 30px;
  background: #f6f6f8;
}

.summary-card {
  margin: 14px;
  padding: 24px 20px 20px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, #ff3c24, #ff1900);
  box-shadow: 0 8px 20px rgba(255, 25, 0, 0.18);
}

.summary-label,
.summary-caption {
  font-size: 13px;
  opacity: 0.86;
}

.summary-value {
  margin: 12px 0 8px;
  font-size: 32px;
  font-weight: 700;
}

.asset-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 0 14px 14px;
}

.asset-item,
.status-card {
  padding: 18px 16px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(31, 35, 41, 0.06);
}

.asset-label {
  color: #666;
  font-size: 13px;
}

.asset-value {
  margin-top: 10px;
  color: #ff1900;
  font-size: 22px;
  font-weight: 700;
}

.status-card {
  margin: 0 14px;
}

.status-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #222;
  font-size: 16px;
  font-weight: 700;
}

.status-tag {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
}

.status-success { color: #1a9b5f; background: #e8f7ef; }
.status-pending { color: #d78100; background: #fff4dc; }
.status-failed { color: #d93025; background: #ffeded; }
.status-default { color: #777; background: #f1f1f1; }

.status-description {
  margin: 14px 0 18px;
  color: #777;
  font-size: 13px;
  line-height: 1.6;
}

.status-card /deep/ .van-button--danger {
  background: #ff1900;
  border-color: #ff1900;
}
</style>
